<template>
  <div class="m-firstBetRefunds">
    <!-- header -->
    <img :src="config.imgBanner" />
    <!-- back -->
    <a
      class="m-firstBetRefunds-home"
      @click="goHome"
    >
      <svg-icon
        v-if="!isAppWebview"
        icon-class="icon-arrowleft"
      />MSport
    </a>
    <!-- share -->
    <img
      v-if="!isAppWebview"
      class="m-firstBetRefunds-share"
      src="./images/share.png"
      @click="goShare"
    />

    <!-- finish stamp -->
    <img
      v-if="isFinished"
      class="m-firstBetRefunds-stamp"
      src="./images/stamp.png"
    />

    <!-- body -->
    <div class="m-firstBetRefunds-body">
      <div class="m-firstBetRefunds-howTo marB22">HOW TO</div>
      <div class="m-firstBetRefunds-topTitle colorP marB16">
        <img src="./images/medal.png" />
        Place Your MSport First Bet Successfully!
      </div>
      <img :src="config.imgBettings" />
      <div class="m-firstBetRefunds-topTitle colorP marB16">
        <img src="./images/medal.png" />
        Win or Get Refunds!
      </div>
      <div class="m-firstBetRefunds-imgs">
        <img src="./images/win.png" />
        <span>OR</span>
        <img :src="config.imgLose" />
      </div>
    </div>

    <!-- logo -->
    <div class="m-firstBetRefunds-logo">
      <img
        src="./images/logo-light.png"
        class="logo-img"
      />
    </div>

    <!-- TEXT -->
    <div class="m-firstBetRefunds-text">
      <div class="m-firstBetRefunds-title marB22 colorP">Example:</div>
      <template v-if="config.exampleList">
        <div
          v-for="(text, index) in config.exampleList"
          :key="index"
          class="m-firstBetRefunds-content"
          :class="{
            marB22: index === config.exampleList.length - 1
          }"
        >
          {{ text }}
        </div>
      </template>

      <div class="m-firstBetRefunds-title marB22 colorP">Terms & Conditions:</div>
      <div
        v-if="config.showPromoPeriod"
        class="m-firstBetRefunds-content marB22"
      >
        1. Promotion Period: {{ showStartTime }} - {{ showEndTime }}
      </div>

      <div
        v-for="(text, index) in config.termsConditions"
        :key="`tc-${index}`"
        class="m-firstBetRefunds-content marB22"
        :class="{
          marB22: index !== config.termsConditions.length - 1
        }"
        v-html="text"
      />
    </div>

    <!-- footer -->
    <div class="m-firstBetRefunds-button">
      <a
        class="m-firstBetRefunds-button-item bet-now"
        @click="btnClick"
        >{{ isFinished ? 'More Promotions' : 'Bet Now' }}</a
      >
      <a
        class="m-firstBetRefunds-button-item go-deposit"
        @click="gotoRecharge"
        >Go Deposit</a
      >
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { storeToRefs } from 'pinia'
import { useAppStore } from '@ms/stores/app'
import { REGION, prefixLink } from '@ms/config/app'
import { fetchActivityDetail } from '@ms/api/marketing'
import { getActivityId } from '@ms/utils-es/discounts'
import share from '@ms/share'
import { tryOpenApp } from 'wap/hybrid'
import { goHome, gotoRecharge } from 'wap/utils/open-page.js'
import 'base/icons/svg/arrowleft.svg'

const config = require(`./${REGION}/config.js`).default

export default {
  name: 'FirstBetRefunds',
  setup() {
    const { isAppWebview } = storeToRefs(useAppStore())

    return {
      isAppWebview,
      goHome,
      gotoRecharge
    }
  },
  data() {
    return {
      config,
      showStartTime: null,
      showEndTime: null,

      isFinished: false // 活动是否过期
    }
  },
  beforeCreate() {
    tryOpenApp()
  },
  created() {
    this.getPromotionTime()
  },

  methods: {
    async getPromotionTime() {
      try {
        const id = getActivityId()
        // const id = '191030074636ACT67088067'
        // const id = '191127094954ACT53977826'
        const data = await fetchActivityDetail(id)
        if (data && data.startTime && data.endTime) {
          this.showStartTime = dayjs(data.startTime).format('YYYY/MM/DD HH:mm')
          this.showEndTime = dayjs(data.endTime).format('YYYY/MM/DD HH:mm')
          this.isFinished = new Date().getTime() > data.endTime
        }
      } catch (error) {
        console.error(error)
      }
    },
    goShare() {
      share({
        ...config.shareInfo,
        hasHideAmountBtn: false,
        channelPrefix: 'firstBetRefunds_share',
        shareUrl: location.origin + location.pathname
      })
    },
    btnClick() {
      const { isFinished } = this
      if (isFinished) {
        location.href = prefixLink('/discounts')
      } else {
        goHome()
      }
    }
  }
}
</script>

<style lang="less">
@import url('~wap/common/style/variable.less');

html,
body {
  background: #1b1b1b;
}

.m-firstBetRefunds {
  position: relative;
  padding-bottom: 80 / @rem;
  color: #fff;

  &-home {
    position: absolute;
    top: 2.8vw;
    left: 0;
    display: flex;
    height: 22 / @rem;
    align-items: center;
    justify-content: center;
    padding: 0 6 / @rem 0 4 / @rem;
    border-radius: 0 15 / @rem 15 / @rem 0;
    background-color: rgba(130, 130, 130, 30%);

    .svg-icon {
      font-size: 12 / @rem;
    }
  }

  &-logo {
    width: 96 / @rem;
    margin: 0 auto 25 / @rem;

    .logo-img {
      width: 100%;
    }
  }

  &-share {
    position: absolute;
    top: 5 / @rem;
    right: 8 / @rem;
    width: 28 / @rem;
  }

  &-stamp {
    position: absolute;
    top: 16 / @rem;
    right: 0 / @rem;
    width: 170 / @rem;
  }

  &-howTo {
    width: 110 / @rem;
    height: 23 / @rem;
    border-radius: 0 0 20 / @rem 20 / @rem;
    margin: 0 auto;
    background: @primary;
    color: #3d2a32;
    font-size: 15 / @rem;
    font-weight: 600;
    line-height: 23 / @rem;
    text-align: center;
  }

  &-topTitle,
  &-title,
  &-content {
    width: (300/360) * 100%;
    margin: 0 auto;
    font-size: 15 / @rem;
    text-align: left;
  }

  &-topTitle {
    & > img {
      position: relative;
      left: -8 / @rem;
      width: 19 / @rem;
    }
  }

  // &-content {
  //   text-align: justify;
  // }

  &-title {
    font-size: 18 / @rem;
    font-weight: 600;
  }

  &-button {
    position: fixed;
    z-index: 1;
    bottom: 0;
    display: flex;
    width: 100%;
    max-width: 750px;
    height: 40 / @rem;
    justify-content: space-between;
    color: #000;
    font-size: 18 / @rem;
    font-weight: 600;
    line-height: 40 / @rem;
    text-align: center;

    &-item {
      width: 50%;
      box-sizing: border-box;
      background: linear-gradient(#ffefad, #fc0);
      color: #000;

      &.bet-now {
        border-right: 1px solid @dark;
      }

      &.go-deposit {
        border-left: 1px solid @dark;
      }
    }
  }

  &-body {
    text-align: center;

    & > img {
      width: (275/360) * 100%;
      margin: 0 auto 6 / @rem;
    }
  }

  &-imgs {
    display: flex;
    width: (275/360) * 100%;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto 30 / @rem;
    color: #fff;
    font-size: 20 / @rem;
    font-weight: 600;

    & > img {
      width: (104/275) * 100%;
    }
  }

  & > img {
    max-width: 100%;
    padding: 0;
    margin: 0;
    outline: 0;
  }

  .marB16 {
    margin-bottom: 16 / @rem;
  }

  .marB22 {
    margin-bottom: 22 / @rem;
  }

  .colorP {
    color: @primary;
  }
}
</style>
